import {
  DATE_CREATION,
  PREMIER_PRODUIT,
} from '@/configuration/presse/produitSalon/produitSalonConfiguration';

export default function genereRegleCommissionLigne() {
  return {
    aSignature: 0,
    aEncaissement: 0,
    passeParMandataire: 0,
    aSignatureNvClient: 0,
    aEncaissementNvClient: 0,
    calculAvance: PREMIER_PRODUIT,
    dateReference: DATE_CREATION,
    dateDebut: null,
    dateFin: null,
    commercialId: null,
    selected: false,
    archive: false,
    produitAchatCommissionId: null,
  };
}
